module.exports = __webpack_public_path__ + "img/zk-icon-commodity.09cc94b8.svg";